export default __webpack_public_path__ + "static/media/ico-s3-score-elevated.b1ad5821.svg";